import { defineStore } from 'pinia'
import { useCreateForm, useEditForm } from "@/stores/_helpers.js";
import toasteventbus from "primevue/toasteventbus";

export const useDevicesStore = defineStore('devices', {
  state: () => ({
    data: undefined,
  }),
  getters: {
    getDevices: (state) => state.data?.data,
  },
  actions: {
    async indexDevices(params = {}) {
      try {
        const response = await axios.get('devices', {params} );
        this.data = response.data;
        return this.data;
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async indexRecentlyViewedDevices(params = {}) {
      try {
        const response = await axios.get('devices-recently-viewed', {params});
        return response.data;
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async createDevice(params = {}) {
      try {
        const response = await axios.get('devices/create', {params} );
        return useCreateForm('devices', response.data);
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async showDevice( deviceId, params = {}) {
      try {
        const response = await axios.get(`devices/${deviceId}`, {params} );
        return response.data;
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async editDevice( deviceId, params = {}) {
      try {
        const response = await axios.get(`devices/${deviceId}/edit`, {params} );
        return useEditForm(`devices/${deviceId}`, response.data);
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async deleteDevice( deviceId, params = {}) {
      try {
        const response = await axios.delete(`devices/${deviceId}`, {params} );
        toasteventbus.emit('add', {
          summary: 'Device Deleted',
          detail: `Device has been deleted.`,
          severity: 'success',
          life: 3000
        });
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async recoverDevice(assetId) {
      try {
        await axios.post(`devices/${assetId}/restore`);
        toasteventbus.emit('add', {
          summary: 'Device Restored',
          detail: `Device has been recovered.`,
          severity: 'success',
          life: 3000
        });
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async duplicateDevice(deviceId, data) {
      try {
        const response = await axios.post(`devices/${deviceId}/duplicate`, data);
        return response.data;
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
  },
});
